<template>
    <div class="bg-white rounded-2xl border border-gray-200 p-4 space-y-4">
        <div>
            <p class="text-lg font-bold text-slate-900">Contrat d'entretien</p>
            <p class="text-sm text-slate-500 mt-0.5">Le contrat sera créé à la fin de l'intervention.</p>
        </div>

        <div v-if="!loaded" class="flex items-center gap-2 text-slate-400 py-4">
            <span class="w-4 h-4 border-2 border-slate-300 border-t-blue-500 rounded-full animate-spin" />
            <span class="text-sm">Chargement…</span>
        </div>

        <template v-else>
            <div class="space-y-3">
                <div>
                    <label class="text-xs font-semibold text-slate-500 mb-1.5 block">Date de début</label>
                    <input @input="newDateDebut" v-model="form.date_debut" type="date" class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" />
                </div>
                <div>
                    <label class="text-xs font-semibold text-slate-500 mb-1.5 block">Date de fin</label>
                    <input v-model="form.date_fin" type="date" class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" />
                </div>
                <!-- <div>
                    <label class="text-xs font-semibold text-slate-500 mb-1.5 block">Prix (€)</label>
                    <input v-model.number="form.prix" type="number" min="0" step="0.01" class="w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm outline-none focus:border-blue-500" placeholder="0.00" />
                </div> -->
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'ContratEntretienStep',
    inject: ['wm'],

    data() {
        return {
            loaded: false,
            form: {
                appareil_id: null,
                adresse_id:  null,
                date_debut:  this.formatDate(new Date()),
                date_fin:    this.formatDate(new Date(new Date().setFullYear(new Date().getFullYear() + 1))),
                // prix:        0,
                intervention_id: null,
            },
        };
    },

    computed: {
        STORAGE_KEY() { return `intervention:${this.wm.intervention.id}:contrat_entretien`; },
    },

    watch: {
        form: {
            deep: true,
            handler(val) {
                if (!this.loaded) return;
                try { localStorage.setItem(this.STORAGE_KEY, JSON.stringify(val)); } catch {}
            },
        },
    },

    created() {
        this.loadFromStorage();
    },

    methods: {
        loadFromStorage() {
            const itvn = this.wm.intervention;
            this.form.appareil_id    = itvn.client_appareil_id;
            this.form.adresse_id     = itvn.adresse_id;
            this.form.intervention_id= itvn.id;
            // this.form.prix           = itvn.societe?.tarif_contrat_entretien || 0;

            try {
                const stored = localStorage.getItem(this.STORAGE_KEY);
                if (stored) this.form = { ...this.form, ...JSON.parse(stored) };
            } catch {}

            this.loaded = true;
        },

        formatDate(date) {
            return date.toISOString().split('T')[0];
        },

        newDateDebut() {
            if (!this.form.date_debut) return;
            const debut = new Date(this.form.date_debut);
            this.form.date_fin = this.formatDate(new Date(debut.setFullYear(debut.getFullYear() + 1)));
            this.$forceUpdate();
        },
    },
};
</script>
